<!-- {{ get | json }} -->

<tt-card *ngIf="!!get">
    <tt-input ttLabel="materialgrade_keyno" [ttModel]="get.materialgrade_keyno" ttReadonly></tt-input>
    <tt-input ttLabel="materialgrade_name" [(ttModel)]="get.materialgrade_name"></tt-input>
    <tt-input-number ttLabel="density_kg_pr_dm3" [(ttModel)]="get.density_kg_pr_dm3" ttDecimals="2"></tt-input-number>
    <tt-input-number ttLabel="std_price_locval" [(ttModel)]="get.std_price_locval" ttDecimals="2"></tt-input-number>
    <tt-input ttLabel="prod_id" [ttModel]="get.prod_id" ttReadonly></tt-input>
    <tt-search ttLabel="prod_name" [(ttModel)]="get.prod_name" [ttSearch]="searchProducts" (ttOnSelected)="onProductSelected($event)" (ttOnClear)="onProductSelected()"></tt-search>
    <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    <tt-button ttText="cancel" (ttClick)="cancel()"></tt-button>
    <tt-button *ngIf="get.materialgrade_keyno > '0'" ttText="delete" ttType="danger" ttIcon="fad fa-trash" (ttClick)="doDelete()"></tt-button>
</tt-card>
